import React, {useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import layout from '../marketing/marketing.module.css';
import styles from './Contact.module.css';
import MarketingHead from '../marketing/components/MarketingHead';
import SiteHeader from '../marketing/components/SiteHeader';
import SiteFooter from '../marketing/components/SiteFooter';
import Eyebrow from '../marketing/components/Eyebrow';
import HeadlineLoop from '../marketing/components/HeadlineLoop';
import Button from '../marketing/components/Button';
import {MailIcon, ArrowRightIcon, PlayIcon, CheckIcon, CopyIcon} from '../marketing/icons/Icons';
import {HOW_TO_ROUTE, VIDEOS_ROUTE} from '../marketing/routes';

const CONTACT_EMAIL = 'contact@ovalview.io';

const Contact = () => {
    const [copied, setCopied] = useState(false);
    const emailRef = useRef(null);

    const copyAddress = async () => {
        try {
            await navigator.clipboard.writeText(CONTACT_EMAIL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            if (emailRef.current && window.getSelection) {
                const range = document.createRange();
                range.selectNodeContents(emailRef.current);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    };

    return (
        <div className={layout.root}>
            <MarketingHead
                title="Contact — Ovalview"
                description="We'd love your feedback on Ovalview. Drop us a line any time."
            />
            <div className={styles.page}>
                <SiteHeader/>

                <main className={styles.main}>
                    <div className={styles.top}>
                        <div className={styles.intro}>
                            <Eyebrow>Contact</Eyebrow>
                            <h1 className={styles.h1}>
                                Contact <HeadlineLoop color="#F5A524">us</HeadlineLoop>
                            </h1>
                            <p className={styles.lead}>We&apos;d love your feedback on Ovalview. Drop us a line any
                                time.</p>
                        </div>

                        <div className={styles.card}>
                            <div className={styles.iconWell}>
                                <MailIcon/>
                            </div>
                            <Eyebrow>Email us</Eyebrow>
                            <a ref={emailRef} href={`mailto:${CONTACT_EMAIL}`} className={styles.emailLink}>
                                {CONTACT_EMAIL}
                            </a>
                            <div className={styles.cardButtons}>
                                <Button href={`mailto:${CONTACT_EMAIL}`} variant="primary" size="section" icon="arrow">
                                    Write to us
                                </Button>
                                <Button
                                    variant="outline"
                                    size="section"
                                    onClick={copyAddress}
                                    className={copied ? styles.copyButtonCopied : ''}
                                >
                                    {copied ? <CheckIcon/> : <CopyIcon/>}
                                    {copied ? 'Copied' : 'Copy address'}
                                </Button>
                                <span aria-live="polite" className={styles.copyStatus}>
                                    {copied ? 'Address copied to clipboard' : ''}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.helperGrid}>
                        <Link to={HOW_TO_ROUTE} className={styles.helperCard}>
                            <div className={styles.helperText}>
                                <span className={styles.helperKicker}>New to Ovalview?</span>
                                <span className={styles.helperTitle}>Read the quick start guide</span>
                            </div>
                            <span className={styles.helperIcon}><ArrowRightIcon/></span>
                        </Link>
                        <Link to={VIDEOS_ROUTE} className={styles.helperCard}>
                            <div className={styles.helperText}>
                                <span className={styles.helperKicker}>Rather watch than read?</span>
                                <span className={styles.helperTitle}>Watch the video guides</span>
                            </div>
                            <span className={styles.helperIcon}><PlayIcon/></span>
                        </Link>
                    </div>
                </main>

                <SiteFooter/>
            </div>
        </div>
    );
};

export default Contact;
